/**
 * Link that opens new tab or window on link click while ignoring
 * other event effects.
 */
function OpenNewWindow({ url, children }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={e => {
        e.preventDefault()
        window.open(url, '_blank', 'noopener,noreferrer')
      }}
    >
      {children}
    </a>
  )
}

export default OpenNewWindow
